import React, { ReactNode } from 'react';
import { atom } from 'recoil';

interface State {
    open: boolean;
    hide: boolean;
    content: ReactNode;
}

export const key = 'toolsState';

export const initialState = {
    open: false,
    hide: true,
    content: <></>,
};

export const state = atom<State>({
    key,
    default: initialState,
});
